import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }

import {computed} from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'Button',
  props: {
  hover: {
    type: Boolean,
    default: true,
    required: false
  },
  outline: {
    type: Boolean,
    default: false,
    required: false
  },
  loading: {
    type: Boolean,
    default: false,
    required: false
  },
  active: {
    type: Boolean,
    default: false,
    required: false
  },
  activeColor: {
    type: String,
    default: "#FFBA35",
    required: false
  },
  to: {
    type: String,
    required: false
  },
  text: {
    type: String,
    required: false,
  },
},
  setup(__props) {

const props = __props
const style = computed(() => {
  if (props.active && props.activeColor) {
    return {
      "--myColor1": props.activeColor,
      "--myColor2": props.activeColor
    }
  }
  return {}
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (__props.loading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("button", {
          style: _normalizeStyle(style.value),
          class: _normalizeClass({active: __props.active, hover: __props.hover, outline: __props.outline})
        }, _cache[0] || (_cache[0] = [
          _createElementVNode("div", { class: "loader" }, null, -1)
        ]), 6)
      ]))
    : (__props.to)
      ? (_openBlock(), _createBlock(_component_router_link, {
          key: 1,
          to: __props.to
        }, {
          default: _withCtx(() => [
            _createElementVNode("button", {
              style: _normalizeStyle(style.value),
              class: _normalizeClass({active: __props.active, hover: __props.hover, outline: __props.outline})
            }, [
              _createTextVNode(_toDisplayString(__props.text) + " ", 1),
              _renderSlot(_ctx.$slots, "default")
            ], 6)
          ]),
          _: 3
        }, 8, ["to"]))
      : (_openBlock(), _createElementBlock("button", {
          key: 2,
          style: _normalizeStyle(style.value),
          class: _normalizeClass({active: __props.active, hover: __props.hover, outline: __props.outline})
        }, [
          _createTextVNode(_toDisplayString(__props.text) + " ", 1),
          _renderSlot(_ctx.$slots, "default")
        ], 6))
}
}

})